module.exports = __webpack_public_path__ + "static/media/logout_icon.5512751c.svg";